export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Администрирование: Журнал сообщений об ошибке",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
